import {
  Box,
} from '@warp-ds/react';
import React from 'react';
import JobSegmentCard from './JobSegmentCard';
import { JobProductInfoGroup } from '../../../types';

type JobAdModelInfoProps = {
  jobProductInfoGroup: JobProductInfoGroup | undefined,
  isLoggedIn: boolean,
  isStaffing: boolean,
};
export default function JobAdModelInfo({
  jobProductInfoGroup, isLoggedIn, isStaffing,
}: JobAdModelInfoProps) {
  const showDiscountedPrices = isLoggedIn && !!jobProductInfoGroup?.hasDiscount;
  return (
    jobProductInfoGroup && (
      !isStaffing ? (
        <div>
          <div className="mb-32">
            <p className="mb-32">
              Vi har delt jobbannonsene i fire kategorier basert på våre data. Det som avgjør hvilken kategori en annonse havner i er:
            </p>
            <ul>
              <li className="text-m list-disc ml-20">Hvilken type stillingannonse som utlyses</li>
              <li className="text-m list-disc ml-20">Hvor enkelt det er å få tak i kandidater til stillingen - både på FINN og i markedet generelt</li>
              <li className="text-m list-disc ml-20">De tiltakene vi må gjennomføre for å nå kandidater til denne typen annonse</li>
            </ul>
          </div>
          {isLoggedIn && (
          <Box info className="mb-32">
            <p>
              Du har publisert
              {' '}
              {jobProductInfoGroup.numberOfPublishedAds}
              {' '}
              annonser de siste 365 dagene
            </p>
          </Box>
          )}

          <div className="flex flex-col lg:flex-row justify-center gap-y-8 lg:gap-x-8">
            {jobProductInfoGroup.jobProductInfo.map((cat) => (
              <JobSegmentCard
                key={cat.specificationId}
                categoryName={cat.heading}
                categoryDescription={cat.description}
                price={cat.specificationPrice.price}
                discountedPrice={cat.specificationPrice.discountedPrice}
                showDiscountedPrices={showDiscountedPrices}
              />
            ))}
          </div>
          <div className="mt-16 mb-32">
            <p className="mb-0">Hvilken kategori en stillingannonse havner i kan variere over tid.</p>
            <p>Alle priser er eksklusiv merverdiavgift.</p>
          </div>
        </div>
      ) : (
        <div>
          <div className="mb-32">
            <p className="mb-32">
              Annonseprisene for bemanning beregnes ut ifra hvor mange bemanningsannonser din bedrift har lagt ut i løpet av de siste 365 dagene.  De fire annonsekategoriene benyttes ikke for denne typen annonser.
            </p>
          </div>
          {isLoggedIn && (
          <Box info className="mb-32">
            <p>
              Du har publisert
              {' '}
              {jobProductInfoGroup.numberOfPublishedAds}
              {' '}
              bemanningannonser de siste 365 dagene
            </p>
          </Box>
          )}
          <div className="mb-32">
            <div className="flex flex-col lg:flex-row justify-center gap-y-8 lg:gap-x-8">
              <JobSegmentCard categoryName="Deltid" price={jobProductInfoGroup.jobProductInfo[0].specificationPrice.price} discountedPrice={jobProductInfoGroup.jobProductInfo[0].specificationPrice.discountedPrice} showDiscountedPrices={showDiscountedPrices} />
              <JobSegmentCard categoryName="Heltid" price={jobProductInfoGroup.jobProductInfo[0].specificationPrice.price} discountedPrice={jobProductInfoGroup.jobProductInfo[0].specificationPrice.discountedPrice} showDiscountedPrices={showDiscountedPrices} />
            </div>
            <p className="mt-16">Alle priser er eksklusiv merverdiavgift.</p>
          </div>
        </div>
      )
    )
  );
}
